// @flow

// Libs
import React from 'react'

// Styles
import { lightGrey } from 'fc-styles/src/colors'

// Components
import UncheckedBox from 'fc-icons/src/UncheckedBox'

export default <UncheckedBox color={lightGrey()} size={20} />
